import styles from './ScoopCheckbox.module.scss'

/**
 * ScoopCheckbox - A custom checkbox component with dark mode support
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.checked=false] - Whether the checkbox is checked
 * @param {function} props.onChange - Change handler function
 * @param {boolean} [props.disabled=false] - Whether the checkbox is disabled
 * @param {'sm' | 'md' | 'lg'} [props.size='md'] - Size of the checkbox (sm: 16px, md: 18px, lg: 20px)
 * @param {string} [props.label] - Label text for the checkbox
 * @param {string} [props.className] - Additional CSS classes
 * @param {...any} props - All other props are passed to the native HTML input element
 */
export const ScoopCheckbox = ({
    checked = false,
    onChange,
    disabled = false,
    size = 'md',
    label,
    className = '',
    ...props
}) => {
    const containerClassName = [
        styles.container,
        styles[size],
        disabled && styles.disabled,
        className,
    ]
        .filter(Boolean)
        .join(' ')

    const handleChange = (e) => {
        e.stopPropagation()
        if (!disabled && onChange) {
            onChange(e)
        }
    }

    return (
        <label className={containerClassName}>
            <input
                type="checkbox"
                className={styles.checkbox}
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                {...props}
            />
            <span className={styles.checkmark}></span>
            {label && <span className={styles.label}>{label}</span>}
        </label>
    )
}

export default ScoopCheckbox
